const theme = {
  colors: {
    darkBlue: '#0c001f',
    red: '#e64848',
    saralPurple: '#7357e9',
    black: '#353535',
    lightGrey: '#e2e2e2',
    darkGrey: ' #667085',
    green: '#12b829',
    orange: '#ff7e20',
    white: '#fff',
    midGrey: '#9d9d9d',
    greyBg: '#f6f6f6',
  },
  shadows: {
    shadow1: `0px -2px 10px rgba(0, 0, 0, 0.05), 0px 0px 5px rgba(0, 0, 0, 0.01),
    0px 12px 16px -4px rgba(16, 24, 40, 0.08),
    0px 4px 6px -2px rgba(16, 24, 40, 0.03)`,
    shadow2: `0px -2px 10px rgba(0, 0, 0, 0.05)`,
  },
};

export default theme;
